import { render, staticRenderFns } from "./DevolucionRecepcionFormComponent.vue?vue&type=template&id=6db676f5&"
import script from "./DevolucionRecepcionFormComponent.vue?vue&type=script&lang=js&"
export * from "./DevolucionRecepcionFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports